import { useSelector } from "react-redux";
import { replaceLoclizationLabel, getLanguageCodeFromSession } from "../../../helpers/CommonHelper";
import { formatCurrency } from "../../../helpers/ConversionHelper";
import { useContext } from "react";
import { useGetPaymentMethodsQuery, usePaypalCreateOrderMutation, useConfirmOrderMutation } from "../../../services/checkout";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../stateManagment/reduxStore";
import { CheckoutStripForm } from "../../components/cart/CheckoutStripForm";
import { FormGroup, Input, Label } from "reactstrap";
import ContentLoader from "react-content-loader";
import React, { useEffect, useState, Fragment, useMemo, useRef, useCallback } from "react";
import rootAction from "../../../stateManagment/actions/rootAction";
import { useGetContentAssetQuery } from "../../../services/content";
import { CARD_MAPPING } from '../../../helpers/Constants';
import { ToggleContext } from "../../../ToggleProvider";
import { GiftCardForm } from "../../components/cart/GiftCardForm";
import { destroySDKScript, PayPalButtons, PayPalMessages, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import initApplePay, { APPLEPAY_DEV_MOCK_MODE, APPLEPAY_MOCK_CONTACTS, getApplePayMockParams, mapApplePayContactToAddress, loadApplePaySdk, createApplePaySession } from "../../../utils/initApplePay";
import Config from "../../../helpers/Config";

export const PaymentMethod = ({ stripeRef, address, inputDisabled = false, confirmOrder }) => {
    const dispatch = useAppDispatch();
    const { data: customCreditPaymentContent, isFetching: isCustomCreditPaymentContentLoading } = useGetContentAssetQuery('payment-credit-amount');
    const { isFetching: isPaymentMethodFetching } = useGetPaymentMethodsQuery(null);
    const LocalizationLabelsArray = [];
    const {
        user: {
            PayrollDeduction: payrollDeduction,
            PDOrderInRecentFortnight
        }
    } = useSelector((state) => state.userReducer);
    const { paymentAmounts, orderTotal, adjustedTotal } = useSelector(state => state.cartReducer);
    const { billingAddress } = useSelector(state => state.userReducer);
    const { billingAddress: checkoutBilling } = useSelector(state => state.checkout);
    const { paymentMethods: availablePaymentMethods, payrollMaxDeductions: maxDeductions, hasSelectPaymentOptions, selectedPaymentMethod } = useSelector((state) => state.checkout);

    const { isToggled, setIsToggled } = useContext(ToggleContext);

    const [paymentTotal, setPaymentTotal] = useState(adjustedTotal ?? orderTotal);
    const [visibleMethods, setVisibleMethods] = useState({});
    const { payrollDeductionSelectOptions, siteDefaultLocation, siteId, ppApiApplePayEnabled, ppApiApplePaySdkUrl } = useSelector(state => state.commonReducer);
    const enablePayPalForOrderAmountGreaterThen = useSelector(state => state.commonReducer.enablePayPalForOrderAmountGreaterThen);
    const enablePayPalPayments = useSelector(state => state.commonReducer.enablePayPalPayments);
    const isPayPalRestrictBasketTotal = useSelector(state => state.commonReducer.isPayPalRestrictBasketTotal);
    const paypalRestrictBasketTotalValue = useSelector(state => state.commonReducer.paypalRestrictBasketTotalValue);
    const [gcAmount, setGcAmount] = useState(0.0);

    const toggleOnAccount = (e) => {
        if (e.target.checked) {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('ON_ACCOUNT'));
            dispatch(rootAction.checkoutActions.setBillingAddress(siteDefaultLocation));
        } else {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('CREDIT_CARD'));
            dispatch(rootAction.checkoutActions.setBillingAddress(billingAddress));
        }

        setVisibleMethods({
            ...visibleMethods,
            ['UAB_PAYROLL_DEDUCTION']: !e.target.checked,
            ['CREDIT_CARD']: !e.target.checked
        });
    };

    useEffect(() => {
        setPaymentTotal(adjustedTotal ?? orderTotal);
    }, [adjustedTotal, orderTotal])

    const changePayroll = (e) => {
        var isVisible = e.target.value === '0';

        if (e.target.value !== '0') {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('UAB_PAYROLL_DEDUCTION'));
            dispatch(rootAction.checkoutActions.setBillingAddress(siteDefaultLocation));
            dispatch(rootAction.commonAction.setUserShipToLocationEnabled(false));
        } else {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('CREDIT_CARD'));
            dispatch(rootAction.checkoutActions.setBillingAddress(billingAddress));
        }

        setVisibleMethods({
            ...visibleMethods,
            ['CREDIT_CARD']: isVisible
        });
        dispatch(rootAction.checkoutActions.setPayrollMaxDeductions(e.target.value));
    };

    const getVisibility = (id, amount) => {
        if (id === "UAB_PAYROLL_DEDUCTION" && PDOrderInRecentFortnight)
            return false;

        if (visibleMethods == {} || visibleMethods[id] === undefined)
            return true;

        return visibleMethods[id];
    };

    if (!visibleMethods) {
        var selected = selectedPaymentMethod ?? 'CREDIT_CARD';
        var visibility = {
            'ON_ACCOUNT': true,
            'UAB_PAYROLL_DEDUCTION': selected !== 'ON_ACCOUNT',
            'CREDIT_CARD': selected === 'CREDIT_CARD'
        };
        setVisibleMethods(visibility);
    }
    useEffect(() => {
        if (!hasSelectPaymentOptions)
            return;

        if (selectedPaymentMethod === '' || selectedPaymentMethod === 'CREDIT_CARD') {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('CREDIT_CARD'));
            dispatch(rootAction.checkoutActions.setBillingAddress(billingAddress));
        }

        var selected = selectedPaymentMethod ?? 'CREDIT_CARD';
        var visibility = {
            'ON_ACCOUNT': true,
            'UAB_PAYROLL_DEDUCTION': selected !== 'ON_ACCOUNT',
            'CREDIT_CARD': selected === 'CREDIT_CARD'
        };
        setVisibleMethods(visibility);
    }, [selectedPaymentMethod, isPaymentMethodFetching, checkoutBilling]);

    // Cleanup PayPal SDK on component unmount to prevent unhandled exceptions
    useEffect(() => {
        return () => {
            try {
                if (window.paypal && window.paypal.Buttons) {
                    // Suppress PayPal SDK errors during unmount
                    const originalError = console.error;
                    console.error = (...args) => {
                        if (args[0]?.includes?.('paypal_js_sdk') || args[0]?.includes?.('unhandled_exception')) {
                            console.warn('PayPal SDK cleanup warning:', ...args);
                        } else {
                            originalError(...args);
                        }
                    };

                    // Restore console.error after cleanup
                    setTimeout(() => {
                        console.error = originalError;
                    }, 100);
                }
            } catch (err) {
                console.warn('PayPal SDK cleanup error:', err);
            }
        };
    }, []);

    const getContentLoader = (id) => {
        var size = 95;
        if (id === "UAB_PAYROLL_DEDUCTION")
            size = 170;
        if (id === "CREDIT_CARD")
            size = 360;
        return (
            <ContentLoader
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                height={size} className='w-100 mt-3'>
                <rect x="0" y="0" rx="6" ry="6" width="100%" height="100%" />
            </ContentLoader>)
    };

    // Check if PayPal is enabled for any payment method
    const isPayPalEnabledForAny = useMemo(() => {
        if (!enablePayPalPayments) return false;

        // Check if there's a PAYPAL payment method with amount > 0
        const paypalMethod = availablePaymentMethods?.find(pm => pm.id === "PayPal");
        if (!paypalMethod) return false;

        const amount = (paymentAmounts[paypalMethod.id] || paymentAmounts['CREDIT_CARD']) ?? 0;
        if (amount === 0) return false;

        // Apply basket total restriction if enabled
        if (isPayPalRestrictBasketTotal) {
            return amount <= paypalRestrictBasketTotalValue;
        }

        return true;
    }, [enablePayPalPayments, availablePaymentMethods, paymentAmounts, isPayPalRestrictBasketTotal, paypalRestrictBasketTotalValue]);

    const PaymentContent = hasSelectPaymentOptions ? (
        <>
            <h6>
                {LocalizationLabelsArray.length > 0 ?
                    replaceLoclizationLabel(LocalizationLabelsArray, "Payment Method", "lbl_check_paymentmethod")
                    :
                    "Payment Method"
                }
            </h6>

            {availablePaymentMethods?.map((paymentMethod, index) => {
                let amount = paymentAmounts[paymentMethod.id];
                if (!getVisibility(paymentMethod.id, amount)) {
                    return null;
                }
                return (
                    <React.Fragment key={paymentMethod.id}>
                        {!inputDisabled ?
                            <div className="card px-4 pt-2 mt-3 bg-light border-0">
                                {paymentMethod.id === "ON_ACCOUNT" &&
                                    <OnAccount
                                        amount={amount}
                                        handleChange={toggleOnAccount}
                                        inputDisabled={inputDisabled}
                                        selected={selectedPaymentMethod === paymentMethod.id} />
                                }
                                {paymentMethod.id === "UAB_PAYROLL_DEDUCTION" &&
                                    <PayrollDeduction
                                        amount={amount}
                                        handleChange={changePayroll}
                                        payrollDeductionData={payrollDeduction}
                                        inputDisabled={inputDisabled}
                                        selected={selectedPaymentMethod === paymentMethod.id ? maxDeductions : 0} />
                                }
                                {paymentMethod.id === "CREDIT_CARD" &&
                                    <CreditCard
                                        methodId={paymentMethod.id}
                                        amount={amount}
                                        cards={paymentMethod.cards}
                                        stripeRef={stripeRef}
                                        address={address} />
                                }
                                {paymentMethod.id === "PayPal" &&
                                    <PaypalCheckout amount={amount} address={address} confirmOrder={confirmOrder} />
                                }
                            </div>
                            :
                            getContentLoader(paymentMethod.id)
                        }
                    </React.Fragment>
                )
            })}
        </>
    ) : (
        <>
            <h6>
                {LocalizationLabelsArray.length > 0 ?
                    replaceLoclizationLabel(LocalizationLabelsArray, "Payment Method", "lbl_check_paymentmethod")
                    :
                    "Payment Method"
                }
            </h6>
            {!isPaymentMethodFetching && paymentTotal > 0 ?
                (() => {
                    let remainingAmount = paymentTotal;
                    if (availablePaymentMethods?.length === 0) {
                        // no payment methods available feedback
                        return (
                            <FormGroup>
                                <Label className="text-danger">
                                    {LocalizationLabelsArray.length > 0 ?
                                        replaceLoclizationLabel(LocalizationLabelsArray, "No payment methods available. Please contact us for assistance.", "lbl_check_nopaymentmethod")
                                        :
                                        "No payment methods available. Please contact us for assistance."
                                    }
                                </Label>
                            </FormGroup>
                        )
                    }
                    // Check if both Credit Card and PayPal are available
                    const creditCardMethod = availablePaymentMethods?.find(pm => pm.id === "CREDIT_CARD");
                    const paypalMethod = availablePaymentMethods?.find(pm => pm.id === "PayPal");
                    const creditCardAmount = creditCardMethod ? (paymentAmounts[creditCardMethod.id] ?? 0) : 0;
                    const paypalAmount = paypalMethod ? ((paymentAmounts[paypalMethod.id] || paymentAmounts['CREDIT_CARD']) ?? 0) : 0;

                    let payPalEnabledForTabs = enablePayPalPayments;
                    if (payPalEnabledForTabs && isPayPalRestrictBasketTotal) {
                        payPalEnabledForTabs = paypalAmount <= paypalRestrictBasketTotalValue;
                    }

                    const applePayEnabledForTabs = !!ppApiApplePayEnabled && payPalEnabledForTabs;

                    const shouldGroupInTabs = creditCardAmount > 0 && paypalAmount > 0 && payPalEnabledForTabs;
                    let tabsRendered = false;

                    return availablePaymentMethods?.map((paymentMethod, index) => {
                        let amount = paymentAmounts[paymentMethod.id] ?? 0;
                        if (paymentMethod.id === "PayPal" && amount === 0) {
                            amount = paymentAmounts['CREDIT_CARD'] ?? 0;
                        }
                        let isPayPalEnabled = enablePayPalPayments;

                        if (isPayPalEnabled && isPayPalRestrictBasketTotal) {
                            isPayPalEnabled = amount <= paypalRestrictBasketTotalValue;
                        }

                        if (paymentMethod.id === "GIFT_CERTIFICATE") {
                            return (
                                <Fragment key={paymentMethod.id}>
                                    <GiftCardForm></GiftCardForm>
                                </Fragment>
                            )
                        }

                        // Group Credit Card and PayPal in tabs if both are available
                        if (paymentMethod.id === "CREDIT_CARD") {
                            if (amount === 0)
                                return null;

                            if (shouldGroupInTabs && !tabsRendered) {
                                tabsRendered = true;
                                return (
                                    <React.Fragment key="payment-tabs">
                                        <PaymentTabs
                                            paypalEnabled={payPalEnabledForTabs}
                                            applePayEnabled={applePayEnabledForTabs}
                                            methodId={paymentMethod.id}
                                            amount={creditCardAmount}
                                            cards={paymentMethod.cards}
                                            stripeRef={stripeRef}
                                            address={address}
                                            confirmOrder={confirmOrder}
                                        />
                                    </React.Fragment>
                                )
                            } else if (!shouldGroupInTabs) {
                                // Render Credit Card standalone if PayPal is not available
                                return (
                                    <React.Fragment key={paymentMethod.id}>
                                        <CreditCard
                                            methodId={paymentMethod.id}
                                            amount={amount}
                                            cards={paymentMethod.cards}
                                            stripeRef={stripeRef}
                                            address={address}
                                        />
                                    </React.Fragment>
                                )
                            }
                            return null;
                        }

                        if (paymentMethod.id === "PayPal") {
                            // Skip if already rendered in tabs with Credit Card
                            if (shouldGroupInTabs) {
                                return null;
                            }

                            // Render standalone PayPal if Credit Card is not available
                            if (amount === 0)
                                return null;

                            return (
                                <React.Fragment key={paymentMethod.id}>
                                    <div className='d-flex justify-content-between align-items-center flex-wrap mb-3'>
                                        <h6 className="my-0">PayPal</h6>
                                        <h6 className="my-0">{formatCurrency(amount)}</h6>
                                    </div>
                                    <PaypalCheckout amount={amount} address={address} confirmOrder={confirmOrder} />
                                </React.Fragment>
                            )
                        }
                        if (paymentMethod.id === "UAB_EMPLOYEE_CREDITS") {
                            return (
                                <div className='d-flex flex-wrap align-items-center mb-3' key={paymentMethod.id}>
                                    {customCreditPaymentContent?.ContentValue?.length > 0 ?
                                        <>
                                            <div className='label d-block' style={{ flex: '1 0 100%' }}>
                                                {LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, paymentMethod.name, "lbl_check_creditcard")
                                                    :
                                                    paymentMethod.name
                                                }
                                            </div>
                                            <p className="font-weight-bold">
                                                {customCreditPaymentContent.ContentValue.replace("{amount}", formatCurrency(amount))}
                                            </p>
                                        </>
                                        :
                                        <>
                                            <span className='label'>
                                                {LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, paymentMethod.name, "lbl_check_creditcard")
                                                    :
                                                    paymentMethod.name
                                                }
                                                :&nbsp;
                                            </span>
                                            <span className="font-weight-bold">
                                                {formatCurrency(amount)}
                                            </span>
                                        </>
                                    }
                                </div>
                            )
                        }
                        if (paymentMethod.id === "UAB_PAYROLL_DEDUCTION" && !PDOrderInRecentFortnight) {
                            return (
                                <div className="clearfix" key={paymentMethod.id}>
                                    <div className='d-flex align-items-center mb-3'>
                                        <span className='label' style={{ textTransform: 'none' }}>
                                            {LocalizationLabelsArray.length > 0 ?
                                                replaceLoclizationLabel(LocalizationLabelsArray, paymentMethod.name, "lbl_check_creditcard")
                                                :
                                                paymentMethod.name
                                            }
                                            :&nbsp;
                                        </span>
                                        <span className="font-weight-bold">
                                            {formatCurrency(amount)}
                                        </span>
                                    </div>
                                    <div className='col-md-6 px-0 mb-3'>
                                        <FormGroup>
                                            <Label>
                                                {LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Max Deductions", "lbl_check_maxdeductions")
                                                    :
                                                    "Max Deductions"
                                                }
                                            </Label>
                                            {payrollDeduction.PayrollDeduction > 1 ?
                                                <Input type='select' required onChange={(e) => dispatch(rootAction.checkoutActions.setPayrollMaxDeductions(e.target.value))}>
                                                    <option value={0}>
                                                        {LocalizationLabelsArray.length > 0 ?
                                                            replaceLoclizationLabel(LocalizationLabelsArray, "Select", "lbl_check_select")
                                                            :
                                                            "Select"
                                                        }
                                                    </option>
                                                    {[...Array(payrollDeduction.PayrollDeduction).keys()].map((index) => {
                                                        var text = index + 1;
                                                        if (payrollDeductionSelectOptions?.length > 0) {
                                                            text = index === 0 ?
                                                                payrollDeductionSelectOptions[0]
                                                                    .replace('$[[amount]]', formatCurrency(amount)) :
                                                                payrollDeductionSelectOptions[1]
                                                                    .replace('$[[amount]]', formatCurrency(amount / (index + 1)))
                                                                    .replace('[[count]]', index + 1)
                                                        }
                                                        return (
                                                            <option key={index} value={index + 1}>{text}</option>
                                                        )
                                                    })}
                                                </Input>
                                                :
                                                <Input type='select' required disabled>
                                                    <option value={payrollDeduction.PayrollDeduction}>{payrollDeduction.PayrollDeduction}</option>
                                                </Input>
                                            }
                                        </FormGroup>
                                    </div>
                                </div>
                            )
                        }
                        if (paymentMethod.id === "ON_ACCOUNT") {
                            return (
                                <div className="clearfix" key={paymentMethod.id}>
                                    <div className='d-flex align-items-center mb-3'>
                                        <span className='font-weight-normal' style={{ textTransform: 'none', fontSize: '1rem', letterSpacing: 0 }}>
                                            {isToggled ? "Allotment" :
                                                LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, paymentMethod.name, "lbl_check_creditcard")
                                                    :
                                                    paymentMethod.name
                                            }
                                            {!isToggled ? <>
                                                :&nbsp;</> : <></>
                                            }
                                        </span>
                                        {!isToggled &&
                                            <span className="font-weight-bold">
                                                {formatCurrency(amount)}
                                            </span>
                                        }
                                    </div>
                                </div>
                            )
                        }
                        return <React.Fragment key={paymentMethod.id}>
                        </React.Fragment>;
                    })
                })()
                :
                <ContentLoader
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    viewBox="0 0 900 150"
                    width='100%'
                    height={200}
                >
                    <rect x="0" y="0" width="100%" height="100%" />
                </ContentLoader>
            }
        </>
    );

    return PaymentContent;
}

const OnAccount = ({ handleChange, amount = 0, selected = false, inputDisabled }) => {
    const siteName = useSelector(state => state.commonReducer.siteName);
    const defaultMessage = `PLEASE BILL ${siteName} FOR THE PURCHASE OF THIS ORDER.`;
    const [message, setMessage] = useState(defaultMessage);
    const { data: onAccountMessage, isFetching: isOnAccountMessageLoading } = useGetContentAssetQuery('on-account-message');
    useEffect(() => {
        if (isOnAccountMessageLoading)
            return;

        if (!!onAccountMessage?.ContentValue)
            setMessage(onAccountMessage?.ContentValue)
        else setMessage(defaultMessage);
    }, [onAccountMessage]);
    return (
        <>
            <div className="d-flex justify-content-between">
                <h6 className="mt-0">On Account</h6>
                <h6 className="mt-0">{formatCurrency(amount)}</h6>
            </div>
            <FormGroup className="form-group custom-control custom-checkbox" check>
                <Input type='checkbox' name='onAccount-chk' id='onAccount-chk' className='custom-control-input'
                    onChange={(e) => handleChange(e)}
                    checked={selected}
                    disabled={inputDisabled}
                >
                </Input>
                <Label for='onAccount-chk' className='custom-control-label' check>
                    <span className='label'>{message}</span>
                </Label>
            </FormGroup>
        </>
    )
}

const PayrollDeduction = ({ payrollDeductionData, amount = 0, handleChange, selected = 0, inputDisabled }) => {
    const dispatch = useAppDispatch();
    const LocalizationLabelsArray = [];
    const { PayrollDeduction: payrollDeduction, AvailablePDBalance: balance } = payrollDeductionData;
    const amountError = balance < amount;

    const { payrollDeductionSelectOptions } = useSelector(state => state.commonReducer);
    const { data: payrollDeductionContent, isFetching: isPayrollDeductionLoading } = useGetContentAssetQuery('payroll-deduction-description');
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h6 className="mt-0">Payroll Deduction</h6>
                <h6 className={`mt-0 ${amountError ? 'text-danger' : ''}`}>{formatCurrency(amount)}</h6>
            </div>
            {amountError &&
                <div className="mb-2 text-danger" >
                    <small>Amount is greater than available Balance. Please remove items or pay with Credit Card.</small>
                </div>
            }
            <div className="mb-4" dangerouslySetInnerHTML={{ __html: payrollDeductionContent?.ContentValue }} />
            <FormGroup>
                <Label>
                    {LocalizationLabelsArray.length > 0 ?
                        replaceLoclizationLabel(LocalizationLabelsArray, "Max Deductions", "lbl_check_maxdeductions")
                        :
                        "Max Deductions"
                    }
                </Label>
                <Input type='select' value={selected} disabled={inputDisabled || amountError} onChange={(e) => handleChange(e)}>
                    <option value={0}>
                        {LocalizationLabelsArray.length > 0 ?
                            replaceLoclizationLabel(LocalizationLabelsArray, "Select an option to use Payroll Deduction", "lbl_check_select")
                            :
                            "Select an option to use Payroll Deduction"
                        }
                    </option>
                    {[...Array(payrollDeduction).keys()].map((index) => {
                        var text = index + 1;
                        if (payrollDeductionSelectOptions?.length > 0) {
                            text = index === 0 ?
                                payrollDeductionSelectOptions[0]
                                    .replace('$[[amount]]', formatCurrency(amount)) :
                                payrollDeductionSelectOptions[1]
                                    .replace('$[[amount]]', formatCurrency(amount / (index + 1)))
                                    .replace('[[count]]', index + 1)
                        }
                        return (
                            <option key={index} value={index + 1}>{text}</option>
                        )
                    })}
                </Input>
            </FormGroup>
        </>
    )
}

const CreditCard = ({ methodId, amount = 0, cards = [], stripeRef, address }) => {
    const LocalizationLabelsArray = [];
    return (
        <React.Fragment key={methodId}>
            <div className='d-flex justify-content-between align-items-center flex-wrap mb-2'>
                <h6 className="my-0">
                    {LocalizationLabelsArray.length > 0 ?
                        replaceLoclizationLabel(LocalizationLabelsArray, "Credit Card", "lbl_check_creditcard")
                        :
                        "Credit Card"
                    }
                </h6>
                <div className="cards d-flex justify-content-center order-3 order-sm-0 px-0 col-12 col-sm-auto">
                    {cards?.map((card, index) => {
                        return (
                            <span key={index} className={`creditcard ${CARD_MAPPING[card.name.toLowerCase()] ?? card.name.toLowerCase()}`}></span>
                        )
                    })}
                </div>
                <h6 className="my-0">{formatCurrency(amount)}</h6>
            </div>
            <CheckoutStripForm
                ref={stripeRef}
                CustBillingAddress={address}
            />
        </React.Fragment>
    )
}

const Credits = ({ amount = 0 }) => {
    const defaultMessage = '';
    const [message, setMessage] = useState(defaultMessage);
    const { data: customCreditPaymentContent, isFetching: isCustomCreditPaymentContentLoading } = useGetContentAssetQuery('payment-credit-amount');
    useEffect(() => {
        if (isCustomCreditPaymentContentLoading)
            return;

        if (!!customCreditPaymentContent?.ContentValue)
            setMessage(customCreditPaymentContent?.ContentValue)
        else setMessage(defaultMessage);
    }, [customCreditPaymentContent]);
    return (
        <>
            <div className="d-flex justify-content-between">
                <h6 className="mt-0">Credits</h6>
                <h6 className="mt-0">{formatCurrency(amount)}</h6>
            </div>
            {!!message &&
                <p className="font-weight-bold">
                    {message?.replace("{amount}", formatCurrency(amount))}
                </p>
            }
        </>
    )
}

const PaymentTabs = ({
    paypalEnabled = true,
    applePayEnabled = true, // TODO: Get from SFCC config (enableApplePayPayments) - same pattern as enablePayPalPayments
    methodId,
    amount = 0,
    cards = [],
    stripeRef,
    address,
    confirmOrder
}) => {
    const dispatch = useAppDispatch();
    const { billingAddress } = useSelector(state => state.userReducer);
    const LocalizationLabelsArray = [];

    const TABS = useMemo(
        () => [
            { key: "card", label: "Credit Card", icon: null },
            { 
                key: "paypal", 
                label: "PayPal",
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" width="48" height="30" role="img" aria-labelledby="pi-paypal" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                        <title id="pi-paypal">PayPal</title>
                        <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/>
                        <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/>
                        <path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"/>
                        <path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"/>
                        <path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"/>
                    </svg>
                )
            },
            {
                key: "applepay",
                label: "Pay",
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" aria-labelledby="pi-applepay" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                        <title id="pi-applepay">Apple</title>
                        <path fill="#000" d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                )
            },
        ],
        []
    );

    const [active, setActive] = useState("card");

    const handleTabSwitch = (tabKey) => {
        setActive(tabKey);

        // Dispatch the selected payment method when switching tabs
        if (tabKey === "card") {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('CREDIT_CARD'));
            dispatch(rootAction.checkoutActions.setBillingAddress(billingAddress));
        } else if (tabKey === "paypal") {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('PayPal'));
            dispatch(rootAction.checkoutActions.setBillingAddress(billingAddress));
        } else if (tabKey === "applepay") {
            dispatch(rootAction.checkoutActions.setSelectedPaymentMethod('ApplePay'));
            dispatch(rootAction.checkoutActions.setBillingAddress(billingAddress));
        }
    };

    const CreditCardUI = (
        <>
            <div className='d-flex justify-content-between align-items-center flex-wrap mb-2'>
                <h6 className="my-0">
                    {LocalizationLabelsArray.length > 0
                        ? replaceLoclizationLabel(LocalizationLabelsArray, "Credit Card", "lbl_check_creditcard")
                        : "Credit Card"}
                </h6>
                <div className="cards d-flex justify-content-center order-3 order-sm-0 px-0 col-12 col-sm-auto">
                    {cards?.map((card, index) => (
                        <span
                            key={index}
                            className={`creditcard ${CARD_MAPPING[card.name.toLowerCase()] ?? card.name.toLowerCase()}`}
                        />
                    ))}
                </div>
                <h6 className="my-0">{formatCurrency(amount)}</h6>
            </div>
            <CheckoutStripForm ref={stripeRef} CustBillingAddress={address} />
        </>
    );

    // Filter visible tabs based on enabled flags
    const visibleTabs = useMemo(() => {
        return TABS.filter(t => {
            if (t.key === 'paypal') return paypalEnabled;
            if (t.key === 'applepay') return applePayEnabled;
            return true; // Credit Card always visible
        });
    }, [paypalEnabled, applePayEnabled]);

    // If neither PayPal nor Apple Pay is enabled → show credit card form only
    if (!paypalEnabled && !applePayEnabled) {
        return <>{CreditCardUI}</>;
    }

    // PayPal enabled → show tabs
    return (
        <div>
            <ul className="nav nav-tabs mb-3" role="tablist">
                {visibleTabs.map(t => (
                    <li className="nav-item" role="presentation" key={t.key}>
                        <button
                            type="button"
                            className={`nav-link ${active === t.key ? "active" : ""}`}
                            onClick={() => handleTabSwitch(t.key)}
                            role="tab"
                            aria-selected={active === t.key}
                        >
                            {t.icon}
                            {t.label}
                        </button>
                    </li>
                ))}
            </ul>

            <div className="tab-content">
                <div className={`tab-pane fade ${active === "card" ? "show active" : ""}`} role="tabpanel" style={{ display: active === "card" ? "block" : "none" }}>
                    {CreditCardUI}
                </div>

                {paypalEnabled && (
                    <div className={`tab-pane fade ${active === "paypal" ? "show active" : ""}`} role="tabpanel" style={{ display: active === "paypal" ? "block" : "none" }}>
                        <PaypalCheckout amount={amount} address={address} confirmOrder={confirmOrder} />
                    </div>
                )}

                {applePayEnabled && (
                    <div className={`tab-pane fade ${active === "applepay" ? "show active" : ""}`} role="tabpanel" style={{ display: active === "applepay" ? "block" : "none" }}>
                        <ApplePayCheckout amount={amount} address={address} confirmOrder={confirmOrder} />
                    </div>
                )}
            </div>
        </div>
    );
};

// PayPal Button Skeleton Loader
const PayPalButtonSkeleton = () => (
    <ContentLoader
        speed={2}
        width="100%"
        height={45}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        style={{ marginBottom: '8px' }}
    >
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="45" />
    </ContentLoader>
);

const PaypalCheckout = ({ amount, address, confirmOrder }) => {
    const [{ isPending }, dispatch] = usePayPalScriptReducer();
    const [isInitialized, setIsInitialized] = useState(null); // null = not loaded, true = loaded & visible, false = loaded & hidden
    const navigate = useNavigate();
    const dispatchRedux = useAppDispatch();

    // RTK Query mutations
    const [createOrder] = usePaypalCreateOrderMutation();
    const [confirmOrderMutation] = useConfirmOrderMutation();

    // Redux state needed for confirmOrder
    const cart = useSelector((state) => state.cartReducer);
    const loginUser = useSelector(state => state.userReducer.user);
    const checkoutActivity = useSelector((state) => state.checkout);
    const { hasSelectPaymentOptions, selectedPaymentMethod } = useSelector((state) => state.checkout);
    const { user: { CreditBalance: creditBalance, PayrollDeduction: payrollDeduction } } = useSelector((state) => state.userReducer);

    // Initialize PayPal SDK on first mount
    useEffect(() => {
        if (isInitialized === null) {
            // Trigger PayPal SDK to load (since it's deferred)
            dispatch({
                type: "setLoadingStatus",
                value: "pending",
            });
            setIsInitialized(true);
        }
    }, [isInitialized, dispatch]);

    // Cleanup PayPal SDK only on component unmount to prevent SDK errors
    useEffect(() => {
        return () => {
            try {
                // Destroy SDK script only when component unmounts
                destroySDKScript();
            } catch (err) {
                console.warn('PayPal SDK cleanup error:', err);
            }
        };
    }, []);

    // Don't render until initialized
    if (isInitialized === null) {
        return <PayPalButtonSkeleton />;
    }

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "300px", maxWidth: "100%" }}>
                {isPending ? (
                    <>
                        <PayPalButtonSkeleton />
                    </>
                ) : (
                    <PayPalButtons
                        fundingSource="paypal"
                        style={{ layout: "vertical", color: "white", label: "checkout" }}
                        userAction="continue"
                        createOrder={async (data, actions) => {
                            setIsInitialized(false);

                            try {
                                const result = await createOrder({
                                    amount: amount.toString(),
                                    currencyCode: "USD",
                                    address: address
                                }).unwrap();

                                setIsInitialized(true);
                                console.log(result);
                                const { orderId } = result;
                                return orderId; // give PayPal SDK the server-created order id
                            } catch (error) {
                                setIsInitialized(true);
                                console.error("Create Order failed:", error);
                                throw new Error("Create Order failed");
                            }
                        }}
                        onApprove={async (data, actions) => {
                            try {
                                // Get the order details from PayPal to capture any address changes
                                const orderDetails = await actions.order.get();
                                
                                // Update shipping address if customer changed it in PayPal
                                if (orderDetails?.purchase_units?.[0]?.shipping?.address) {
                                    const shippingInfo = orderDetails.purchase_units[0].shipping;
                                    const paypalShippingAddress = {
                                        firstName: shippingInfo.name?.given_name || shippingInfo.name?.full_name?.split(' ')[0] || '',
                                        lastName: shippingInfo.name?.surname || shippingInfo.name?.full_name?.split(' ').slice(1).join(' ') || '',
                                        address1: shippingInfo.address.address_line_1 || '',
                                        address2: shippingInfo.address.address_line_2 || '',
                                        city: shippingInfo.address.admin_area_2 || '',
                                        stateCode: shippingInfo.address.admin_area_1 || '',
                                        postalCode: shippingInfo.address.postal_code || '',
                                        countryCode: shippingInfo.address.country_code || 'US',
                                        phone: '',
                                        fullName: shippingInfo.name?.full_name || ''
                                    };
                                    dispatchRedux(rootAction.checkoutActions.setShippingAddress(paypalShippingAddress));
                                }

                                // Prepare payment amounts
                                let paymentAmounts = JSON.parse(JSON.stringify(cart.paymentAmounts));

                                if (!paymentAmounts || Object.keys(paymentAmounts)?.length === 0) {
                                    navigate('/cart?WebError=An unknown error occurred. Please try again.');
                                    return false;
                                }

                                if (hasSelectPaymentOptions) {
                                    Object.keys(paymentAmounts).forEach(key => {
                                        if (key !== 'PayPal')
                                            paymentAmounts[key] = 0;
                                    });
                                }
                                
                                // Call the confirmOrder mutation
                                await confirmOrderMutation({
                                    shippingAddress: checkoutActivity.shippingAddress,
                                    shippingMethod: cart.shippingMethod,
                                    billingAddress: checkoutActivity.billingAddress,
                                    paymentMethods: checkoutActivity.paymentMethods,
                                    pdMaxDeductions: Number(checkoutActivity.payrollMaxDeductions || 0),
                                    ccTokenResponse: null, // No credit card token for PayPal
                                    creditCard: null,
                                    employee: {
                                        CreditBalance: creditBalance,
                                        PayrollDeduction: payrollDeduction
                                    },
                                    selectedPaymentMethod: 'PayPal',
                                    paymentAmounts
                                }).unwrap()
                                    .then(() => {
                                        // Update both checkout and cart reducers with PayPal payment amounts
                                        dispatchRedux(rootAction.checkoutActions.setIsInOrderReview(true));
                                        dispatchRedux(rootAction.checkoutActions.setPaymentAmounts(paymentAmounts));
                                        navigate('/' + getLanguageCodeFromSession() + '/order-review');
                                    })
                                    .catch((err) => {
                                        console.error('Confirm order error:', err);
                                        alert(err?.data?.message ?? 'An error occurred while confirming your order. Please try again.');
                                    });

                                return true;
                            } catch (error) {
                                console.error('PayPal onApprove error:', error);
                                alert('An error occurred while processing your payment. Please try again.');
                                return false;
                            }
                        }}
                        onError={(err) => {
                            console.error("PayPal error", err);
                            // TODO: usin js alert as an example, display the message in the jumbotron above page
                            alert("We couldn't start the payment. Please review your cart and try again.");
                        }}
                    />
                )}

                {/* Pay Later Button - Same component, different fundingSource */}
                {!isPending && (
                    <PayPalButtons
                        fundingSource="paylater"
                        style={{ layout: "vertical", color: "gold" }}
                        userAction="continue"
                        createOrder={async (data, actions) => {
                            setIsInitialized(false);

                            try {
                                const result = await createOrder({
                                    amount: amount.toString(),
                                    currencyCode: "USD",
                                    address: address
                                }).unwrap();

                                setIsInitialized(true);
                                console.log(result);
                                const { orderId } = result;
                                return orderId; // give PayPal SDK the server-created order id
                            } catch (error) {
                                setIsInitialized(true);
                                console.error("Create Order failed:", error);
                                throw new Error("Create Order failed");
                            }
                        }}
                        onApprove={async (data, actions) => {
                            try {
                                // Get the order details from PayPal to capture any address changes
                                const orderDetails = await actions.order.get();
                                
                                // Update shipping address if customer changed it in PayPal
                                if (orderDetails?.purchase_units?.[0]?.shipping?.address) {
                                    const shippingInfo = orderDetails.purchase_units[0].shipping;
                                    const paypalShippingAddress = {
                                        firstName: shippingInfo.name?.given_name || shippingInfo.name?.full_name?.split(' ')[0] || '',
                                        lastName: shippingInfo.name?.surname || shippingInfo.name?.full_name?.split(' ').slice(1).join(' ') || '',
                                        address1: shippingInfo.address.address_line_1 || '',
                                        address2: shippingInfo.address.address_line_2 || '',
                                        city: shippingInfo.address.admin_area_2 || '',
                                        stateCode: shippingInfo.address.admin_area_1 || '',
                                        postalCode: shippingInfo.address.postal_code || '',
                                        countryCode: shippingInfo.address.country_code || 'US',
                                        phone: '',
                                        fullName: shippingInfo.name?.full_name || ''
                                    };
                                    dispatchRedux(rootAction.checkoutActions.setShippingAddress(paypalShippingAddress));
                                }

                                // Prepare payment amounts
                                let paymentAmounts = JSON.parse(JSON.stringify(cart.paymentAmounts));

                                if (!paymentAmounts || Object.keys(paymentAmounts)?.length === 0) {
                                    navigate('/cart?WebError=An unknown error occurred. Please try again.');
                                    return false;
                                }

                                if (hasSelectPaymentOptions) {
                                    Object.keys(paymentAmounts).forEach(key => {
                                        if (key !== 'PayPal')
                                            paymentAmounts[key] = 0;
                                    });
                                }
                                
                                // Call the confirmOrder mutation
                                await confirmOrderMutation({
                                    shippingAddress: checkoutActivity.shippingAddress,
                                    shippingMethod: cart.shippingMethod,
                                    billingAddress: checkoutActivity.billingAddress,
                                    paymentMethods: checkoutActivity.paymentMethods,
                                    pdMaxDeductions: Number(checkoutActivity.payrollMaxDeductions || 0),
                                    ccTokenResponse: null, // No credit card token for PayPal
                                    creditCard: null,
                                    employee: {
                                        CreditBalance: creditBalance,
                                        PayrollDeduction: payrollDeduction
                                    },
                                    selectedPaymentMethod: 'PayPal',
                                    paymentAmounts
                                }).unwrap()
                                    .then(() => {
                                        // Update both checkout and cart reducers with PayPal payment amounts
                                        dispatchRedux(rootAction.checkoutActions.setIsInOrderReview(true));
                                        dispatchRedux(rootAction.checkoutActions.setPaymentAmounts(paymentAmounts));
                                        navigate('/' + getLanguageCodeFromSession() + '/order-review');
                                    })
                                    .catch((err) => {
                                        console.error('Confirm order error:', err);
                                        alert(err?.data?.message ?? 'An error occurred while confirming your order. Please try again.');
                                    });

                                return true;
                            } catch (error) {
                                console.error('PayPal Pay Later onApprove error:', error);
                                alert('An error occurred while processing your payment. Please try again.');
                                return false;
                            }
                        }}
                        onError={(err) => {
                            console.error("PayPal Pay Later error", err);
                            alert("We couldn't start the payment. Please review your cart and try again.");
                        }}
                    />
                )}

                {isPending ? <PayPalButtonSkeleton /> : <PayPalMessages amount={(+amount || 0.01).toFixed(2)} />}
            </div>
        </div>
    );
};

// Apple Pay Checkout Component - uses utilities from initApplePay.js
const ApplePayCheckout = ({ amount, address, confirmOrder }) => {
    const ppApiApplePayEnabled = useSelector((state) => state.commonReducer.ppApiApplePayEnabled);
    const applePayMock = getApplePayMockParams();
    const isMockMode = APPLEPAY_DEV_MOCK_MODE || !!applePayMock?.enabled;

    if (!isMockMode && !ppApiApplePayEnabled) {
        return null;
    }

    return <ApplePayCheckoutInner amount={amount} address={address} confirmOrder={confirmOrder} applePayMock={applePayMock} />;
};

const ApplePayCheckoutInner = ({ amount, address, confirmOrder, applePayMock }) => {
    const isMockMode = APPLEPAY_DEV_MOCK_MODE || !!applePayMock?.enabled;
    const mockScenario = (applePayMock?.scenario || 'success').trim();

    const [{ isPending }, dispatch] = usePayPalScriptReducer();
    const navigate = useNavigate();
    const dispatchRedux = useAppDispatch();

    const ppApiApplePaySdkUrl = useSelector((state) => state.commonReducer.ppApiApplePaySdkUrl);
    const cart = useSelector((state) => state.cartReducer);
    const checkoutActivity = useSelector((state) => state.checkout);
    const { hasSelectPaymentOptions } = useSelector((state) => state.checkout);
    const { user: { CreditBalance: creditBalance, PayrollDeduction: payrollDeduction } } = useSelector((state) => state.userReducer);

    const [createPayPalOrder] = usePaypalCreateOrderMutation();
    const [confirmOrderMutation] = useConfirmOrderMutation();
    const [applePayAvailable, setApplePayAvailable] = useState(isMockMode);
    const [isEligible, setIsEligible] = useState(isMockMode);
    const [applePayConfig, setApplePayConfig] = useState(null);
    const [error, setError] = useState(null);
    const [isInitialized, setIsInitialized] = useState(isMockMode);
    const [isApplePaySdkLoaded, setIsApplePaySdkLoaded] = useState(isMockMode || !!window.ApplePaySession);
    const applePayButtonRef = useRef(null);

    useEffect(() => {
        if (!isMockMode && !isPending && !isInitialized) {
            setIsInitialized(true);
        }
    }, [isMockMode, isPending, isInitialized]);

    // Load Apple Pay SDK using shared utility
    useEffect(() => {
        if (isMockMode) {
            setIsApplePaySdkLoaded(true);
            return;
        }

        loadApplePaySdk(ppApiApplePaySdkUrl).then((loaded) => {
            setIsApplePaySdkLoaded(loaded);
        });
    }, [isMockMode, ppApiApplePaySdkUrl]);

    useEffect(() => {
        const checkApplePay = async () => {
            if (isMockMode) {
                setApplePayConfig({ countryCode: 'US', isEligible: true });
                setApplePayAvailable(true);
                setIsEligible(true);
                return;
            }

            if (!isApplePaySdkLoaded && !window.ApplePaySession) {
                return;
            }

            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

            try {
                const config = await initApplePay();
                if (!config) {
                    setError(isLocalhost ? 'Apple Pay requires HTTPS.' : 'Apple Pay is not available.');
                    return;
                }

                setApplePayAvailable(true);
                setApplePayConfig(config);
                setIsEligible(true);
            } catch (err) {
                console.error('Error initializing Apple Pay:', err);
                setError('Error initializing Apple Pay');
            }
        };

        if (!isPending && isInitialized) {
            checkApplePay();
        }
    }, [isMockMode, isPending, isInitialized, isApplePaySdkLoaded]);

    const getApplePayPaymentAmounts = () => {
        let paymentAmounts = JSON.parse(JSON.stringify(cart.paymentAmounts));
        if (!paymentAmounts || Object.keys(paymentAmounts)?.length === 0) {
            return null;
        }

        if (hasSelectPaymentOptions) {
            Object.keys(paymentAmounts).forEach((key) => {
                if (key !== 'PayPal') paymentAmounts[key] = 0;
            });
        }

        return paymentAmounts;
    };

    // Shared confirm-order logic used by both mock and real flows
    const completeApplePayOrder = async (shippingContact, billingContact) => {
        const applePayShippingAddress = mapApplePayContactToAddress(shippingContact);
        const applePayBillingAddress = mapApplePayContactToAddress(billingContact);

        const paymentAmounts = getApplePayPaymentAmounts();
        if (!paymentAmounts) {
            throw new Error('Missing payment amounts');
        }

        dispatchRedux(rootAction.checkoutActions.setIsInOrderReview(true));

        await confirmOrderMutation({
            shippingAddress: applePayShippingAddress || checkoutActivity.shippingAddress,
            shippingMethod: cart.shippingMethod,
            billingAddress: applePayBillingAddress || checkoutActivity.billingAddress,
            paymentMethods: checkoutActivity.paymentMethods,
            pdMaxDeductions: Number(checkoutActivity.payrollMaxDeductions || 0),
            ccTokenResponse: null,
            creditCard: null,
            employee: {
                CreditBalance: creditBalance,
                PayrollDeduction: payrollDeduction,
            },
            selectedPaymentMethod: 'ApplePay',
            paymentAmounts,
            applePayContacts: {
                shippingContact: shippingContact || null,
                billingContact: billingContact || null,
            },
        }).unwrap();

        // Update Redux checkout state with Apple Pay addresses so order-review
        // and order-confirmation pages display the correct address (they read
        // from checkoutActivity, not from the SFCC basket).
        const finalShipping = applePayShippingAddress || checkoutActivity.shippingAddress;
        const finalBilling = applePayBillingAddress || checkoutActivity.billingAddress;
        dispatchRedux(rootAction.checkoutActions.setShippingAddress(finalShipping));
        dispatchRedux(rootAction.checkoutActions.setBillingAddress(finalBilling));
        dispatchRedux(rootAction.checkoutActions.setPaymentAmounts(paymentAmounts));
        navigate('/' + getLanguageCodeFromSession() + '/order-review');
    };

    const handleApplePayClick = useCallback(async () => {
        try {
            if (isMockMode) {
                if (mockScenario === 'cancel') {
                    return;
                }

                if (mockScenario === 'fail_validateMerchant') {
                    setError('Error initializing Apple Pay');
                    return;
                }

                const createOrderResp = await createPayPalOrder({
                    amount: amount.toString(),
                    currencyCode: 'USD',
                    address,
                }).unwrap();

                const orderId = createOrderResp?.orderId;
                if (!orderId) throw new Error('Missing PayPal order id');

                if (mockScenario === 'fail_paypalConfirm') {
                    setError('PayPal ApplePay confirm failed');
                    return;
                }

                if (mockScenario === 'fail_confirmOrder') {
                    setError('Confirm order failed');
                    return;
                }

                await completeApplePayOrder(APPLEPAY_MOCK_CONTACTS.shipping, APPLEPAY_MOCK_CONTACTS.billing);
                return;
            }

            if (!applePayConfig) {
                return;
            }

            // Use createApplePaySession from initApplePay.js (mirrors UA storefront pattern)
            createApplePaySession({
                config: applePayConfig,
                amount,
                onPaymentAuthorized: async (payment, applepay) => {
                    const createOrderResp = await createPayPalOrder({
                        amount: amount.toString(),
                        currencyCode: 'USD',
                        address,
                    }).unwrap();

                    const orderId = createOrderResp?.orderId;
                    if (!orderId) throw new Error('Missing PayPal order id');

                    await applepay.confirmOrder({
                        orderId,
                        token: payment.token,
                        billingContact: payment.billingContact,
                    });

                    await completeApplePayOrder(payment?.shippingContact, payment?.billingContact);
                },
                onError: (errorMsg) => setError(errorMsg),
            });
        } catch (err) {
            console.error('Error starting Apple Pay session:', err);
            setError('An error occurred with Apple Pay. Please try again or use another payment method.');
        }
    }, [amount, address, applePayConfig, cart.paymentAmounts, cart.shippingMethod, checkoutActivity.billingAddress, checkoutActivity.paymentMethods, checkoutActivity.payrollMaxDeductions, checkoutActivity.shippingAddress, confirmOrderMutation, createPayPalOrder, creditBalance, dispatchRedux, hasSelectPaymentOptions, isMockMode, mockScenario, navigate, payrollDeduction]);

    useEffect(() => {
        const el = applePayButtonRef.current;
        if (!el) return;
        if (!isEligible) return;

        el.style.cursor = 'pointer';
        el.style.pointerEvents = 'auto';

        const onNativeClick = (e) => {
            e?.stopPropagation?.();
            handleApplePayClick();
        };

        el.addEventListener('click', onNativeClick);
        return () => {
            el.removeEventListener('click', onNativeClick);
        };
    }, [handleApplePayClick, isEligible]);

    if (isPending || !isInitialized) {
        return (
            <ContentLoader
                speed={2}
                width="100%"
                height={120}
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="0" y="0" rx="4" ry="4" width="100%" height="20" />
                <rect x="0" y="30" rx="4" ry="4" width="100%" height="44" />
                <rect x="0" y="84" rx="4" ry="4" width="100%" height="30" />
            </ContentLoader>
        );
    }

    if (error || !applePayAvailable) {
        return (
            <div className="text-center py-4">
                <p className="text-muted mb-2">
                    Pay securely with Apple Pay using Touch ID or Face ID.
                </p>
                <div className="alert alert-warning" role="alert">
                    {error || 'Apple Pay is not available on this device or browser.'}
                </div>
                <small className="text-muted">
                    Apple Pay requires a compatible device with Touch ID, Face ID, or passcode enabled.
                </small>
            </div>
        );
    }

    return (
        <div className="apple-pay-content py-3">
            {isMockMode && (
                <div className="alert alert-info mb-3" role="alert" style={{ fontSize: '12px' }}>
                    <strong>MOCK MODE:</strong> applepayScenario={mockScenario}
                </div>
            )}

            <p className="mb-3" style={{ fontSize: '18px', fontWeight: '400' }}>
                Pay securely with Apple Pay using Touch ID or Face ID.
            </p>

            <div id="applepay-container" className="apple-pay-button-container mb-3" style={{ maxWidth: '400px', minHeight: '44px' }}>
                {isMockMode ? (
                    <button
                        type="button"
                        onClick={handleApplePayClick}
                        style={{
                            width: '100%',
                            height: '48px',
                            backgroundColor: '#000',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '19px',
                            fontWeight: '400',
                            cursor: 'pointer',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        }}
                    >
                        Mock Apple Pay ({mockScenario})
                    </button>
                ) : !isEligible ? (
                    <ContentLoader
                        speed={2}
                        width="100%"
                        height={44}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <rect x="0" y="0" rx="4" ry="4" width="100%" height="44" />
                    </ContentLoader>
                ) : (
                    <apple-pay-button
                        id="btn-applepay"
                        buttonstyle="black"
                        type="buy"
                        locale="en"
                        ref={applePayButtonRef}
                        style={{ display: 'block', width: '100%', height: '44px', cursor: 'pointer', pointerEvents: 'auto' }}
                    />
                )}
            </div>

            <small className="text-muted d-block">
                Apple Pay requires a compatible device with Touch ID, Face ID, or passcode enabled.
            </small>
        </div>
    );
};